import { createContext, useContext } from "react";

/**
 * Lets a deeplinked setting open the `SettingsAdvanced` disclosure it sits in.
 * Collapsed content is `visibility: hidden` at zero height, so without this a
 * catalog link to an advanced setting scrolls to something nobody can see.
 */
export const SettingsAdvancedContext = createContext<
  { reveal(): void } | undefined
>(undefined);

export function useRevealEnclosingAdvanced(): (() => void) | undefined {
  return useContext(SettingsAdvancedContext)?.reveal;
}
